import { render, staticRenderFns } from "./jobcardview.vue?vue&type=template&id=7c049114&"
import script from "./jobcardview.vue?vue&type=script&lang=js&"
export * from "./jobcardview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c049114')) {
      api.createRecord('7c049114', component.options)
    } else {
      api.reload('7c049114', component.options)
    }
    module.hot.accept("./jobcardview.vue?vue&type=template&id=7c049114&", function () {
      api.rerender('7c049114', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/production/jobcard/jobcard-view/jobcardview.vue"
export default component.exports